import { useEffect, useState } from "react";

/* Material UI */
import { Grid } from "@material-ui/core";
import Box from "@mui/material/Box";
import { Divider } from "@mui/material";
import { getBrands } from "utils/LaravelApi/LaravelAPI";
import CarsBrandItem from "views/CategorySection/Components/CarBrandItem";
import { LaravelCategories, SLUG } from "helpers/helpers";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

export default function CarsBrandSelector() {
  const { typeSlug } = useParams();
  
  const [availableBrands, setAvailableBrands] = useState(null);
  const [notAvailableBrands, setNotAvailableBrands] = useState(null);

  useEffect(() => {
    const category = LaravelCategories[SLUG[typeSlug]];
    const fetchBrands = async () => {
      const brands = await getBrands(category);
      if (brands.success) {
        setAvailableBrands(brands.data.marcas_disponibles);
        setNotAvailableBrands(brands.data.marcas_no_disponibles);
      }
    };
    fetchBrands();
    // eslint-disable-next-line
  }, []);

  return (
    <Box
      component="div"
      sx={{
        paddingLeft: { xs: "5%", md: "5%" },
        paddingRight: { xs: "5%", md: "5%" },
      }}
      style={{
        display: "flex",
        justifyContent: "center",
        marginBottom: "30px",
        flexDirection: "column",
      }}
    >
      <Grid container spacing={3}>
        {availableBrands !== null &&
          availableBrands.map((item, idx) => {
            return (
              <CarsBrandItem
                key={idx + "- avBrand"}
                name={item.nombre}
                url={item.url}
              />
            );
          })}
        <BrandsDivider />
        {notAvailableBrands !== null &&
          notAvailableBrands.map((item, idx) => {
            return (
              <CarsBrandItem
                key={idx + "- notAvBrand"}
                name={item.nombre}
                url={item.url}
                disabled
              />
            );
          })}
      </Grid>
    </Box>
  );
}

function BrandsDivider() {
  return (
    <>
      <Box
        component={Grid}
        item
        sx={{
          display: { xs: "block", md: "none" },
        }}
        style={{
          backgroundColor: "#f2f2f2",
          height: "100px",
          width: "100vw",
          "margin-inline": "-5%",
        }}
      />
      <Box
        component={Grid}
        sx={{
          fontSize: { xs: "20px", md: "30px" },
          textAlign: { xs: "center", md: "left" },
          textDecoration: { md: "underline" },
        }}
        key={"not brands"}
        item
        xs={12}
        style={{ fontFamily: "Nunito Sans, sans-serif" }}
      >
        No disponibles
      </Box>
      <Box
        component={Grid}
        item
        xs={12}
        sx={{ display: { xs: "flex", md: "none" }, justifyContent: "center" }}
      >
        <Divider sx={{ width: "100%", mx: 2, my: 0 }} />
      </Box>
    </>
  );
}
